export const HANDLED_ERROR_BASE_ROUTE = '/handled-error'

export enum HandledPageErrorType {
  ACCOUNT_SUSPENDED = 'AccountSuspended',
  NO_NEWSLETTER = 'NoNewsletter',
  UNKNOWN = 'Unknown',
}

export const ERROR_TYPE_QUERY = 'type'